<template>
  <ContactForm :open="openContactForm" @hide-modal="hideContactForm()" />
  <div
    :class="[
      'flex flex-col border rounded-lg',
      checked ? 'border-success bg-success-muted' : '',
      !checked ? 'border-border' : '',
      disabled ? 'cursor-not-allowed' : 'cursor-pointer',
    ]">
    <div class="p-4 gap-4 flex items-center" :title="disabled && $t(paymentMethod.requirement)">
      <div v-if="checked" class="size-4 flex-none rounded-full bg-success text-white flex justify-center items-center">
        <CheckIcon class="size-3" />
      </div>
      <div v-else class="size-4 bg-muted border border-input rounded-full flex-none"></div>
      <div class="size-14 bg-white flex-none flex items-center justify-center rounded-full">
        <img :src="image" class="size-8" aria-label="Payment Method Logo" alt="Payment Method Logo" />
      </div>
      <div class="grid">
        <div :class="checked ? 'font-bold' : 'font-medium'">{{ $t(paymentMethod.title) }}</div>
        <div class="text-muted-foreground hidden lg:block">{{ $t(paymentMethod.description) }}</div>
      </div>
      <div v-if="!isB2C" class="ml-auto flex-none font-semibold">
        <div v-if="percentage">{{ percentage }}% {{ $t("fee") }}</div>
        <div v-else-if="paymentMethod.fee && !isB2C">{{ paymentMethod.fee }} {{ $t("fee") }}</div>
        <div v-else>
          <span>{{ $t("Free") }}</span>
        </div>
      </div>
    </div>
    <div v-if="disabled" class="p-t-0 px-4 pb-4 cursor-default">
      <Alert v-if="paymentMethod.requirement" status="warning">
        <i18n-t
          :keypath="paymentMethod.requirement"
          tag="span">
          <template #alink>
            <a class="cursor-pointer font-medium underline underline-offset-3" href="/user/invoices?sorting=created:desc">
              {{ $t("here") }}
            </a>
          </template>
          <template #acontact>
            <span class="cursor-pointer font-medium underline underline-offset-3" @click="openContactForm = true">
              {{ $t("contact our support team").toLowerCase() }}
            </span>
          </template>
        </i18n-t>
      </Alert>
    </div>
  </div>
</template>
<script setup>
const { method } = defineProps({
  method: { required: true },
  percentage: Number,
  checked: Boolean,
  disabled: Boolean,
});

import { methods } from ".";
import { ref } from "vue";
import { CheckIcon } from "@heroicons/vue/24/solid";
import { isB2C } from "@/brandconfig";
import { computedAsync } from "@vueuse/core";
import { Alert } from "@xs2event/js-lib/components";
import ContactForm from "@/components/ContactForm.vue";

const paymentMethod = methods[method];

const openContactForm = ref(false);
const hideContactForm = () => {
  openContactForm.value = false;
};

const image = computedAsync(async () => {
  try {
    const imageModule = await import(`@/assets/images/payment-methods/${method}.svg`);
    return imageModule.default;
  } catch (e) {
    console.error(e);
  }
});
</script>
